import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import uploadImg from "../../../../../picture/UploadDocument.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import forwardImg from "../../../../../picture/forward.png";
import letterAImg from "../../../../../picture/letterA.png";
import arrowImg from "../../../../../picture/NextLanguage.png";
import printImg from "../../../../../picture/print.png";
import { useRef, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";

const formatDate = (val) => {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d)) return val;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
};

const cyrillicMap = {
  "Akt o proceni rizika": "Акт о процени ризика",
  "Odluka": "Одлука",
  "Izjava": "Изјава",
  "Overena zadnja strana": "Оверена задња страна",
  "Izmena": "Измена",
  "Dopuna": "Допуна",
  "Program osposobljavanja": "Програм обуке",
  "Pravilnik": "Правилник",
  "Uputstvo za pruzanje PP": "Упутство за пружање ПП",
  "Sema ormarica": "Шема ормарића",
  "Spisak obucenih za pruzanje PP": "Списак обучених за ПП",
  "Ostala uputstva": "Остала упутства"
};

// Vraca path za izabrani tip
function getPath(dokument, type) {
  if (!type) return null;
  const map = { word: dokument.word_path, pdf: dokument.pdf_path, image: dokument.image_path, scan: dokument.scan_path, text: dokument.text_path };
  return map[type] || null;
}

function buildWorkplaceHtml(d) {
  const posebniSvi = [
    ...(d.posebni_uslovi || []).map((x) => x.naziv),
    ...(d.strani_jezici || []).map((x) => x.naziv),
    ...(d.vozacke_dozvole || []).map((x) => x.naziv),
    ...(d.it_vestine || []).map((x) => x.naziv),
    ...(d.dodatni_uslovi || []).map((x) => x.naziv),
  ].join("<br/>");
  const imenaSvi = (d.imena || []).join("<br/>");
  return `<!DOCTYPE html>
<html lang="sr"><head><meta charset="UTF-8"/>
<title>${d.workplace_name}</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 11pt; padding: 30px; max-width: 1100px; margin: 0 auto; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 10px 16px; vertical-align: top; border: 1px solid #000; font-size: 11pt; }
  .label { font-weight: bold; text-transform: uppercase; width: 28%; }
  .value { text-transform: uppercase; }
  .full { font-weight: normal; text-transform: none; }
  .print-btn { position: fixed; bottom: 20px; right: 20px; padding: 8px 24px; background: #1565C0; color: #fff; border: none; border-radius: 4px; font-size: 13px; cursor: pointer; }
  @media print { .print-btn { display: none; } }
</style>
</head><body>
<table>
  <tr><td class="label">${d.workplace_id}.</td><td class="value">${d.workplace_name}</td></tr>
  <tr><td class="label">РИЗИК</td><td class="value">${d.stepen_rizika || "-"}</td></tr>
  <tr><td class="label">СТРУЧНА СПРЕМА</td><td class="value">${d.sprema || "-"}</td></tr>
  <tr><td class="label">РАДНО ИСКУСТВО</td><td class="value">${d.iskustvo || "-"}</td></tr>
  <tr><td class="label">ПОСЕБНИ УСЛОВИ</td><td class="value">${posebniSvi || "-"}</td></tr>
  <tr><td class="label">ЗАПОСЛЕНИ</td><td class="value">${imenaSvi || "-"}</td></tr>
  <tr><td colspan="2" class="full" style="white-space:pre-line">${d.opis_poslova || ""}</td></tr>
</table>
<button class="print-btn" onclick="window.print()">🖨 Штампај</button>
</body></html>`;
}

function WorkplaceRow({ wp }) {
  const { baseUrl } = useGlobalContext();
  const [selected, setSelected] = useState(false);

  const fetchAndOpen = async (doPrint = false) => {
    try {
      const res = await fetch(`${baseUrl}/workplaces/read_one.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ workplace_id: wp.workplace_id }),
      });
      const json = await res.json();
      if (json.status !== 200) return;
      const html = buildWorkplaceHtml(json.data);
      const pw = window.open("", "_blank");
      pw.document.write(html);
      pw.document.close();
      if (doPrint) setTimeout(() => pw.print(), 500);
    } catch (e) { console.error(e); }
  };

  const handleShare = async () => {
    if (!selected) return;
    try {
      const res = await fetch(`${baseUrl}/workplaces/read_one.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ workplace_id: wp.workplace_id }),
      });
      const json = await res.json();
      if (json.status !== 200) return;
      const html = buildWorkplaceHtml(json.data);
      const blob = new Blob([html], { type: "text/html" });
      const file = new File([blob], `${wp.workplace_name}.html`, { type: "text/html" });
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: wp.workplace_name });
      } else if (navigator.share) {
        await navigator.share({ title: wp.workplace_name, text: wp.workplace_name });
      }
    } catch (e) { if (e.name !== "AbortError") console.error(e); }
  };

  const iconStyle = (active) => ({ width: "30px", cursor: active ? "pointer" : "default", opacity: active ? 1 : 0.3 });

  return (
    <tr style={{ backgroundColor: "#f5f5f5", borderBottom: "1px solid #e0e0e0" }}>
      <td style={styles.cell} />
      <td style={styles.smallCell}><div style={{ width: "25px", height: "25px", margin: "auto" }} /></td>
      <td onClick={() => setSelected((p) => !p)} style={{ ...styles.smallCell, border: selected ? "2px solid black" : "" }}>
        <div style={{ backgroundColor: "green", width: "25px", height: "25px", margin: "auto" }} />
      </td>
      <td style={styles.smallCell}><div style={{ width: "25px", height: "25px", margin: "auto" }} /></td>
      <td style={styles.smallCell}><div style={{ width: "25px", height: "25px", margin: "auto" }} /></td>
      <td style={{ fontSize: "1.5em", fontWeight: "bold", padding: "5px 5px 5px 30px", textAlign: "start" }}>
        {wp.workplace_name}
      </td>
      <td style={styles.cell} />
      <td style={styles.smallCell}>
        <img src={visibleImg} style={iconStyle(selected)} onClick={() => selected && fetchAndOpen(false)} />
      </td>
      <td style={styles.smallCell}>
        <img src={forwardImg} style={iconStyle(selected)} onClick={handleShare} />
      </td>
      <td style={styles.smallCell}>
        <img src={downloadImg} style={{ ...iconStyle(selected), width: "25px" }} onClick={() => selected && fetchAndOpen(false)} />
      </td>
      <td style={styles.smallCell}>
        <img src={printImg} style={{ ...iconStyle(selected), width: "25px" }} onClick={() => selected && fetchAndOpen(true)} />
      </td>
      <td style={styles.smallCell} />
    </tr>
  );
}

function VazecaTabela({
  dokumenta = [],
  moveToArhivirani,
  checkedRows = [],
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll,
  workplaces = [],
}) {
  const [selectedField, setSelectedField] = useState({ documentId: "", documentType: "" });
  const [editData, setEditData] = useState({ documentId: "", documentType: "" });
  const [isOpenEditConfirm, setIsOpenEditConfirm] = useState(false);
  const [fileNewDocument, setFileNewDocument] = useState(null);
  const [aktExpanded, setAktExpanded] = useState(false);

  const fileInputRef = useRef();
  const { dictionary, baseUrl } = useGlobalContext();

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType }
    );
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) setCheckedRows(checkedRows.filter((r) => r !== id));
    else setCheckedRows([...checkedRows, id]);
  };

  const handleCheckAll = () => {
    if (isCheckedAll) setCheckedRows([]);
    else setCheckedRows(dokumenta.map((z) => z.id));
    setIsCheckedAll((prev) => !prev);
  };

  const handleClickUpload = (id) => {
    if (id === selectedField.documentId && selectedField.documentType) setEditData(selectedField);
    else setEditData({ documentId: id, documentType: "" });
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) { setEditData({ documentId: "", documentType: "" }); return; }
    setFileNewDocument(file);
    setIsOpenEditConfirm(true);
  };

  const handleConfirmEdit = () => { console.log(editData, fileNewDocument); cancelEditConfirm(); };
  const cancelEditConfirm = () => { setEditData({ documentId: "", documentType: "" }); setIsOpenEditConfirm(false); setFileNewDocument(null); };

  // Akcije za red dokumenta
  const getFileUrl = (dokument) => {
    if (selectedField.documentId !== dokument.id) return null;
    const path = getPath(dokument, selectedField.documentType);
    if (!path) return null;
    return `${baseUrl.replace("/api", "")}/${path}`;
  };

  const handlePreview = (dokument) => {
    const url = getFileUrl(dokument);
    if (!url) return;
    window.open(url, "_blank");
  };

  const handlePrint = (dokument) => {
    const url = getFileUrl(dokument);
    if (!url) return;
    const pw = window.open(url, "_blank");
    if (pw) pw.addEventListener("load", () => { try { pw.print(); } catch (e) {} });
  };

  const handleDownload = (dokument) => {
    const url = getFileUrl(dokument);
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop();
    a.click();
  };

  const handleShare = async (dokument) => {
    const url = getFileUrl(dokument);
    if (!url) return;
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const fileName = url.split("/").pop();
      const file = new File([blob], fileName, { type: blob.type });
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: dokument.vrsta });
      } else if (navigator.share) {
        await navigator.share({ title: dokument.vrsta, url });
      } else {
        window.open(url, "_blank");
      }
    } catch (e) { if (e.name !== "AbortError") console.error(e); }
  };

  const isSelected = (dokument) => selectedField.documentId === dokument.id && !!selectedField.documentType && !!getPath(dokument, selectedField.documentType);
  const iconStyle = (active) => ({ width: "30px", cursor: active ? "pointer" : "default", opacity: active ? 1 : 0.3 });

  return (
    <>
     <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <input type="checkbox" checked={isCheckedAll} onChange={handleCheckAll} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}><img src={wordImg} style={{ width: "30px" }} /></th>
            <th style={styles.smallCell}><img src={pdfImg} style={{ width: "30px" }} /></th>
            <th style={styles.smallCell}><img src={imageImg} style={{ width: "30px" }} /></th>
            <th style={styles.smallCell}><img src={scanImg} style={{ width: "30px" }} /></th>
            {/* RAZDVOJENE KOLONE U THEAD */}
            <th style={{ fontSize: "1.5em", ...styles.cell, textAlign: 'start' }}>{dictionary["tip"]}</th>
            <th style={{ fontSize: "1.5em", ...styles.cell, textAlign: 'start' }}>{dictionary["nazivDokumenta"]}</th>
            <th style={{ fontSize: "1.5em", ...styles.cell }}>{dictionary["dodato"]}</th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
          </tr>
        </thead>
        <tbody>
          {dokumenta.map((dokument) => {
            const isAkt = dokument.vrsta === "Akt o proceni rizika";
            const active = isSelected(dokument);
            return (
              <>
                <tr key={dokument.id}>
                  <td style={styles.cell}>
                    <input type="checkbox" checked={checkedRows.includes(dokument.id)} onChange={() => handleCheckRow(dokument.id)} style={{ width: "30px" }} />
                  </td>
                  {["word", "pdf", "image", "scan"].map((type) => (
                    <td key={type}
                      onClick={() => handleSelectDocument(dokument.id, type)}
                      style={{ ...styles.smallCell, border: selectedField.documentId === dokument.id && selectedField.documentType === type ? "2px solid black" : "" }}
                    >
                      <div style={{ backgroundColor: dokument[type], width: "25px", height: "25px", margin: "auto" }} />
                    </td>
                  ))}
                  {/* KOLONA 1: VRSTA (Npr. Odluka, Dopuna...) */}
                  <td style={{ fontSize: "1.3em", color: "#666", padding: "5px", textAlign: "start" }}>
                    {cyrillicMap[dokument.vrsta]}
                  </td>
                  {/* KOLONA 2: NAZIV (Tvoj tačan naziv fajla/dokumenta) */}
                  <td style={{ fontSize: "1.5em", fontWeight: "bold", padding: "5px", textAlign: "start" }}>
                    {dokument.naziv}
                  </td>
                  <td style={{ fontSize: "1.3em", fontWeight: "bold", ...styles.cell }}>
                    {formatDate(dokument.created_at)}
                  </td>
                  <td style={styles.smallCell}>
                    <img src={visibleImg} style={iconStyle(active)} onClick={() => handlePreview(dokument)} />
                  </td>
                  <td style={styles.smallCell}>
                    <img src={forwardImg} style={iconStyle(active)} onClick={() => handleShare(dokument)} />
                  </td>
                  <td style={styles.smallCell}>
                    <img src={downloadImg} style={{ ...iconStyle(active), width: "25px" }} onClick={() => handleDownload(dokument)} />
                  </td>
                  <td onClick={() => handleClickUpload(dokument.id)} style={styles.smallCell}>
                    <img src={uploadImg} style={{ width: "25px" }} />
                  </td>
                  <td style={styles.smallCell}>
                    {isAkt ? (
                      <img
                        src={arrowImg}
                        onClick={() => setAktExpanded((p) => !p)}
                        style={{ width: "10px", cursor: "pointer", transform: aktExpanded ? "rotate(270deg)" : "rotate(90deg)", transition: "transform 0.3s ease" }}
                      />
                    ) : (
                      <img src={letterAImg} onClick={() => moveToArhivirani(dokument)} style={{ width: "20px" }} />
                    )}
                  </td>
                </tr>

                {isAkt && aktExpanded && workplaces.map((wp) => (
                  <WorkplaceRow key={`wp-${wp.workplace_id}`} wp={wp} />
                ))}
              </>
            );
          })}
        </tbody>
      </table>

      <input type="file" accept="image/*, .pdf, .docx" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileInputChange} />

      {isOpenEditConfirm && (
        <ConfirmationModal
          text={`${dictionary[editData.documentType === "scan" ? "confirmAddDocumentScan" : editData.documentType === "image" ? "confirmAddDocumentImage" : "confirmAddDocument"]} ${dictionary["warningDeleteOld"]}`}
          handleConfirm={handleConfirmEdit}
          handleCancel={cancelEditConfirm}
        />
      )}
    </>
  );
}

export default VazecaTabela;